import React from 'react';
import { Overview } from '../../../api/cafAutomation';
import { formatAgo, formatDayTime } from '../format';
import { Drawer } from '../Overlay';
import { useToast } from '../ToastContext';

/** Engine health in plain lines (spec §5.8). IDs and raw values go to the clipboard only. */
export const TechDrawer: React.FC<{ overview: Overview; onClose: () => void }> = ({ overview, onClose }) => {
  const toast = useToast();
  const updated = formatAgo(overview.generated_at);
  const lines = [
    updated === 'Unknown' ? "We don't know when these numbers were updated."
      : `Numbers updated ${updated.charAt(0).toLowerCase()}${updated.slice(1)}`,
    overview.live.last_decided_at
      ? `Last email the AI read: ${formatDayTime(overview.live.last_decided_at)}`
      : "The AI hasn't read an email yet",
    overview.send_limit
      ? `Client emails being sent now: ${overview.send_limit.occupied} of ${overview.send_limit.slot_limit} allowed`
      : 'Client emails being sent now: unknown',
    overview.last_problem_at
      ? `Last problem: the AI couldn't finish an email (${formatDayTime(overview.last_problem_at)})`
      : 'Last problem: none in the last 7 days',
  ];
  const copy = async () => {
    const details = {
      generated_at: overview.generated_at,
      switch: { mode: overview.switch.mode, raw: overview.switch.raw, epoch: overview.switch.epoch },
      days: overview.days, live: overview.live, workflows_paused: overview.workflows_paused,
      control_revision: overview.control_revision, send_limit: overview.send_limit,
      last_problem_at: overview.last_problem_at, capabilities: overview.capabilities,
    };
    try {
      await navigator.clipboard.writeText(JSON.stringify(details, null, 2));
      toast.saved('Copied.');
    } catch {
      toast.failed("Couldn't copy. Try again.");
    }
  };
  return (
    <Drawer eyebrow="Automation" title="Technical details" onClose={onClose}
      footer={(
        <>
          <button type="button" className="ui-btn ui-btn--secondary ui-btn--md" onClick={() => { void copy(); }}>Copy details for support</button>
          <button type="button" className="ui-btn ui-btn--ghost ui-btn--md" onClick={onClose}>Close</button>
        </>
      )}>
      <details className="cur-more">
        <summary>Engine health</summary>
        <ul className="cur-more-body cur-checklist">
          {lines.map((line) => <li key={line}>{line}</li>)}
        </ul>
      </details>
    </Drawer>
  );
};
